/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

export const SelectEmailProvider = ({
  setEmailProvider,
  setFormPopupOpen,
  open,
  setOpen,
}: any) => {
  return (
    <Dialog open={open} onOpenChange={setOpen} modal={true}>
      <form>
        <DialogContent className="sm:max-w-sm">
          <DialogHeader>
            <DialogTitle>Email Provider</DialogTitle>
          </DialogHeader>
          <div>
            <Select
              onValueChange={(prop) => {
                setEmailProvider(prop);
                setFormPopupOpen(true);
                setOpen(false);
              }}
            >
              <SelectTrigger className="w-full ">
                <SelectValue placeholder="Select Email Provider" />
              </SelectTrigger>
              <SelectContent>
                <SelectGroup>
                  <SelectItem value="gmail">Gmail</SelectItem>
                  <SelectItem value="outlook">Outlook</SelectItem>
                </SelectGroup>
              </SelectContent>
            </Select>
          </div>
          <DialogFooter>
            <DialogClose asChild>
              <Button variant="outline">Cancel</Button>
            </DialogClose>
          </DialogFooter>
        </DialogContent>
      </form>
    </Dialog>
  );
};
